import type { TypographyProps } from '@mui/material';

const DEFAULT_LETTER_SPACING = 0 as const;
const DEFAULT_LINE_HEIGHT = 1.4 as const;
const DEFAULT_FONT_SIZE = 14 as const;
const FONT_WEIGHT_LIGHT = 300 as const;
const FONT_WEIGHT_REGULAR = 400 as const;
const FONT_WEIGHT_MEDIUM = 500 as const;
const FONT_WEIGHT_BOLD = 700 as const;

const typography = {
  fontFamily: 'Roboto, sans-serif',
  fontSize: DEFAULT_FONT_SIZE,
  fontWeight: FONT_WEIGHT_REGULAR,
  lineHeight: DEFAULT_LINE_HEIGHT,
  letterSpacing: DEFAULT_LETTER_SPACING,
  fontWeightLight: FONT_WEIGHT_LIGHT,
  fontWeightRegular: FONT_WEIGHT_REGULAR,
  fontWeightMedium: FONT_WEIGHT_MEDIUM,
  fontWeightBold: FONT_WEIGHT_BOLD,
  h1: {
    fontSize: 96,
    fontWeight: FONT_WEIGHT_LIGHT,
    lineHeight: 1.3,
    letterSpacing: -1.5,
  },
  h2: {
    fontSize: 60,
    fontWeight: FONT_WEIGHT_LIGHT,
    lineHeight: 1.2,
    letterSpacing: -0.5,
  },
  h3: {
    fontSize: 48,
    fontWeight: FONT_WEIGHT_REGULAR,
    lineHeight: 1.17,
    letterSpacing: DEFAULT_LETTER_SPACING,
  },
  h4: {
    fontSize: 34,
    fontWeight: FONT_WEIGHT_REGULAR,
    lineHeight: 1.24,
    letterSpacing: 0.25,
  },
  h4Alt: {
    fontSize: 30,
    fontWeight: FONT_WEIGHT_REGULAR,
    lineHeight: 1.24,
    letterSpacing: 0.25,
  },
  h5: {
    fontSize: 24,
    fontWeight: FONT_WEIGHT_REGULAR,
    lineHeight: 1.33,
    letterSpacing: DEFAULT_LETTER_SPACING,
  },
  h6: {
    fontSize: 22,
    fontWeight: FONT_WEIGHT_REGULAR,
    lineHeight: 1.3,
    letterSpacing: DEFAULT_LETTER_SPACING,
  },
  h6Alt: {
    fontSize: 18,
    fontWeight: FONT_WEIGHT_REGULAR,
    lineHeight: 1.3,
    letterSpacing: DEFAULT_LETTER_SPACING,
  },
  subtitle1: {
    fontSize: 16,
    lineHeight: 1.3,
    fontWeight: FONT_WEIGHT_REGULAR,
    letterSpacing: 0.15,
  },
  subtitle2: {
    fontSize: 14,
    lineHeight: 1.57,
    fontWeight: FONT_WEIGHT_MEDIUM,
    letterSpacing: 0.1,
  },
  body1: {
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: FONT_WEIGHT_REGULAR,
    letterSpacing: 0.15,
  },
  body2: {
    fontSize: 14,
    lineHeight: 1.43,
    fontWeight: FONT_WEIGHT_REGULAR,
    letterSpacing: 0.17,
  },
  caption: {
    fontSize: 12,
    lineHeight: 1.66,
    fontWeight: FONT_WEIGHT_REGULAR,
    letterSpacing: DEFAULT_LETTER_SPACING,
  },
  captionSmall: {
    fontSize: 10,
    lineHeight: 1.2,
    fontWeight: FONT_WEIGHT_REGULAR,
    letterSpacing: DEFAULT_LETTER_SPACING,
  },
  captionXSmall: {
    fontSize: 8,
    lineHeight: 1.2,
    fontWeight: FONT_WEIGHT_REGULAR,
    letterSpacing: DEFAULT_LETTER_SPACING,
  },
  overline: {
    fontSize: 12,
    lineHeight: 2.6,
    fontWeight: FONT_WEIGHT_REGULAR,
    letterSpacing: 1,
  },
};

export const typographyVariants = Object.entries(typography)
  .filter(([, value]) => typeof value === 'object')
  .map(([key]) => key) as TypographyProps['variant'][];

export default typography;
